import { FormControl, Tooltip } from "@mui/material";
import Checkbox from "core/data-entry/Checkbox.tsx";
import { normalizeCurrency } from "core/utils/normalizeCurrency.ts";
import { motion } from "framer-motion";
import { useCallback, useMemo, useState } from "react";
import Select from "react-select";
import CloseIcon from "../../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../components/FiltroV2/FiltroV2";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro.js";
import LoadingBar from "../../../components/LoadingBar/LoadingBar.js";
import ModalConfigTabela from "../../../components/ModalConfigTabela/ModalConfigTabela.tsx";
import NewIcon from "../../../components/NewIcon/NewIcon.js";
import SelectEmbarqueV2 from "../../../components/SelectEmbarqueV2/SelectEmbarqueV2.js";
import { TabelaVirtualizadaGenerica } from "../../../components/TabelaVirtualizadaGenerica/TabelaVirtualizadaGenerica.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import { useToast } from "../../../contexts/ToastContext.tsx";
import IconButton from "../../../core/components/IconButton.tsx";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import Separator from "../../../core/components/Separator.tsx";
import { useRowClick } from "../../../hooks/useRowClick.ts";
import { valorMaskKm } from "../../../regex/valorMaskKm.js";
import { colunasHistorico } from "./Constants.js";

export default function PedidoList({
	telaCadastro,
	itensFiltro,
	valuesPesquisa,
	setValuesPesquisa,
	buscarSearch,
	limpar,
	setTelaCadastro,
	setEditando,
	dadosTabela,
	loading,
	values,
	tabelaRedux,
	setOpen,
	setOpenUsuario,
	setTextoSucesso,
	setTextoErro,
	setOpenToastErro,
	buscarPedidoPorId,
	props,
	editando,
	disablePedido,
	loadingCadastro,
	setValues,
	setDadosTabela,
	dadosTabelaCopia,
	setTabelaRedux,
	valuesSelect,
	setValuesSelect,
	opcoesRota,
	opcoesCliente,
	opcoesEmbarcador,
	opcoesDestinatario,
	listaValores,
	validator,
	setValidator,
	pedidoValido,
	setPedidoValido,
	tipoRotaValido,
	setTipoRotaValido,
	freteFiscalValido,
	setFreteFiscalValido,
	pedagioValido,
	setPedagioValido,
	kmValido,
	setKMValido,
	clienteValido,
	setClienteValido,
	embarcadorValido,
	setEmbarcadorValido,
	destinatarioValido,
	setDestinatarioValido,
	classificacaoValido,
	setClassificacaoValido,
	freteMotoristaValido,
	setFreteMotoristaValido,
	taxaIcms,
	freteNormal,
	semAutorizacaoFreteFiscal,
	loadingSelectRota,
	loadingSelectCliente,
	loadingSelectValorEmbarque,
	setOpenCadastroRota,
	setOpenCadastroCliente,
	setOpenCadastroValorEmbarque,
	setDisable,
	setIdAtual,
	verificaPedidoExiste,
	buscarTaxaIcms,
	editar,
	clearValorEmbarque,
	labelRota,
	estiloRota,
	customStylesErro,
	labelCliente,
	labelEmbarcador,
	labelDestinatario,
	setValuesClientesKm,
	cadastrar,
}) {
	const { tabelaEmpresa, tabelaUsuario } = useProfile();

	const [openConfig, setOpenConfig] = useState(false);

	const { showToast } = useToast();

	const handleCloseConfig = useCallback(() => {
		setOpenConfig(false);
		showToast("Configurações salvas com sucesso!", "success");
	}, [showToast]);

	const handleSingleClick = useCallback(
		(row) => {
			if (!row) return;
			setTabelaRedux({
				colunaSelecionada: row.idPedido,
				usuarioAlteracao: row.usuario || row.usuarioAlteracao || null,
				dataAlteracao: row.data || row.dataAlteracao || null,
				row,
			});
		},
		[setTabelaRedux]
	);

	const handleDoubleClick = useCallback(() => {
		setTelaCadastro(true);
		setEditando(true);
	}, [setEditando, setTelaCadastro]);

	const handleRowClick = useRowClick({
		idKey: "idPedido",
		onSelect: handleSingleClick,
		onDouble: handleDoubleClick,
	});

	const getRowClassName = useCallback(
		(row) => {
			if (!tabelaRedux?.colunaSelecionada) return "";
			return row.idPedido === tabelaRedux.colunaSelecionada
				? "selecionado"
				: "";
		},
		[tabelaRedux?.colunaSelecionada]
	);

	const handleCellClassName = useCallback((coluna, _, _rowIndex) => {
		const field = coluna?.field ?? coluna?.campo ?? coluna?.nome;
		if (!field) return undefined;

		const classes = [];
		if (
			[
				"freteFiscal",
				"icms",
				"pedagio",
				"classificacao",
				"km",
				"freteMotorista",
				"freteNormal",
			].includes(field)
		) {
			classes.push("td-right");
		}

		return classes.length ? classes.join(" ") : undefined;
	}, []);

	const colunasVisiveis = useMemo(() => {
		return tabelaEmpresa.Pedido.filter((colunaEmpresa) =>
			tabelaUsuario.Pedido.some(
				(colunaUsuario) =>
					colunaUsuario.field === colunaEmpresa.field &&
					colunaUsuario.visivel === "true"
			)
		);
	}, [tabelaEmpresa.Pedido, tabelaUsuario.Pedido]);

	const buildOpcoesComFiltro = (
		opcoes,
		filtro,
		limit = 15
	) => {
		const termo = filtro.trim().toLowerCase();

		const base = termo
			? opcoes.filter((data) => {
				const cnpjLimpo = data.cnpj?.replace(/\D/g, "");

				return (
					data.nomeFantasia?.toLowerCase().includes(termo) ||
					data.apelido?.toLowerCase().includes(termo) ||
					data.cnpj?.includes(termo) ||
					cnpjLimpo?.includes(termo)
				);
			})
			: opcoes.slice(0, limit);

		return base.map((data) => ({
			value: `${data.nomeFantasia} | ${data.cnpj} | ${data.cnpj?.replace(/\D/g, "")}`,
			label: `${data.nomeFantasia} | ${data.apelido || "Favor, cadastrar apelido"
				}`,
			...data,
		}));
	};

	const [filtroCliente, setFiltroCliente] = useState("");
	const [filtroEmbarcador, setFiltroEmbarcador] = useState("");
	const [filtroDestinatario, setFiltroDestinatario] = useState("");

	const opcoesClienteDefault = useMemo(
		() => buildOpcoesComFiltro(opcoesCliente, filtroCliente),
		[opcoesCliente, filtroCliente]
	);

	const opcoesEmbarcadorDefault = useMemo(
		() => buildOpcoesComFiltro(opcoesEmbarcador, filtroEmbarcador),
		[opcoesEmbarcador, filtroEmbarcador]
	);

	const opcoesDestinatarioDefault = useMemo(
		() => buildOpcoesComFiltro(opcoesDestinatario, filtroDestinatario),
		[opcoesDestinatario, filtroDestinatario]
	);

	const buildOpcoesRotaComFiltro = (opcoes, filtro, limit = 15) => {
		const termo = filtro.trim().toLowerCase();

		const base = termo
			? opcoes.filter((data) => {
				const nome = (data.nome ?? "").toLowerCase();
				const codigo = String(data.codigo ?? "").toLowerCase();
				const id = String(data.id ?? "").toLowerCase();

				return (
					nome.includes(termo) ||
					codigo.includes(termo) ||
					id.includes(termo)
				);
			})
			: opcoes.slice(0, limit);

		return base.map((data) => ({
			value: data.nome,
			label: data.nome,
			...data,
		}));
	};

	const [filtroRota, setFiltroRota] = useState("");

	const opcoesRotaDefault = useMemo(
		() => buildOpcoesRotaComFiltro(opcoesRota, filtroRota),
		[opcoesRota, filtroRota]
	);

	return (
		<>
			{!telaCadastro ? (
				<MotionContainer key="PedidoScreenContainer">
					<div className="content-container">
						<Separator size="md" />
						<div className="filtro-pedido">
							<FiltroV2
								classe="div-filtrar-embarque-v2"
								classOption="select-options-pedido"
								itensFiltro={itensFiltro}
								valuesPesquisa={valuesPesquisa}
								setValuesPesquisa={setValuesPesquisa}
								buscarSearch={buscarSearch}
								limpar={limpar}
							/>
							<Separator direction="horizontal" size="md" />
							<Tooltip title={<p>Abrir configurações colunas</p>}>
								<IconButton
									onClick={() => setOpenConfig(true)}
									icon="Settings"
									size="2xl"
									theme="dark"
									backgroundColor="#FFFFFF"
									hoverColor="#CCC"
								/>
							</Tooltip>
						</div>
						<Separator size="xs" />
						<TabelaVirtualizadaGenerica
							dados={dadosTabela}
							colunas={colunasVisiveis}
							rowHeight={20}
							isLoading={loading}
							getRowClassName={getRowClassName}
							onRowClick={handleRowClick}
							centralized={false}
							getCellClassName={handleCellClassName}
						/>
					</div>
					<div className="footer-space-between">
						<div>
							<CustomButtonV2
								classCss="custom-button-cadastrar"
								classText="button-texto-cadastrar"
								icone="iconeSave"
								titulo="Cadastrar"
								cor="#0946B8"
								valor={values}
								onClick={() => {
									setTelaCadastro(true);
									setEditando(false);
								}}
							/>
							<CustomButtonV2
								classCss="custom-button-editar"
								classText="button-texto-editar"
								titulo="Editar"
								icone="iconeEdit"
								cor="#CDCDCD"
								valor={values}
								onClick={() => {
									if (tabelaRedux.colunaSelecionada) {
										setTelaCadastro(true);
										setEditando(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
							<CustomButtonV2
								classCss="custom-button-deletar"
								classText="button-texto-cadastrar"
								titulo="Deletar"
								icone="iconeDelete"
								cor="#DC2D2D"
								valor={values}
								onClick={() => {
									if (tabelaRedux.colunaSelecionada) {
										setOpen(true);
										setTextoSucesso("Deletado Com Sucesso");
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
						</div>
						<div>
							<CustomButtonV2
								classCss="custom-button-user"
								classText="button-texto-user"
								titulo="Obter Usuário"
								cor="#FFFFFF"
								valor={values}
								onClick={() => {
									if (tabelaRedux.usuarioAlteracao) {
										setOpenUsuario(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
							<CustomButtonV2
								classCss="custom-button-historico"
								classText="button-texto-user"
								titulo="Histórico"
								cor="#FFFFFF"
								valor={values}
								onClick={() => {
									if (tabelaRedux.colunaSelecionada) {
										buscarPedidoPorId(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
						</div>
					</div>
				</MotionContainer>
			) : (
				<MotionContainer key="PedidoCadastroContainer">
					<div className="content-container">
						{!props.desabilitar ? (
							<div className="texto-cadastro-container">
								{props.botaoFechar !== false && (
									<div style={{ width: 29, height: 29 }} />
								)}
								<div className="texto-cadastro">
									<p className="indicador-emb">{"Dados de Pedido / "}</p>
									{editando ? (
										<p className="indicador-emb">{"Detalhes de Pedido"}</p>
									) : (
										<p className="indicador-emb">{"Cadastro de Pedido"}</p>
									)}
									<HeaderCadastro texto="" />
								</div>
								{props.botaoFechar !== false && (
									<div className="close-btn">
										<CloseIcon
											onClick={() => {
												setValues({});
												setDadosTabela(dadosTabelaCopia);
												setValuesSelect({});
												setTelaCadastro(false);
												setEditando(false);
												setTabelaRedux({});
											}}
										/>
									</div>
								)}
							</div>
						) : (
							<></>
						)}
						<div className="flex-column">
							<div className="container-select-emb">
								<div className="coluna-3-emb">
									<div
										className={pedidoValido ? "coluna-emb" : "coluna-emb-erro"}
									>
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												Pedido:
											</p>
											<input
												type="number"
												id="pedido"
												className={
													!pedidoValido ? "validacao-erro" : "input-emb"
												}
												style={{ width: "206px" }}
												disabled={disablePedido || props.desabilitar}
												onChange={(e) => {
													setPedidoValido(true);
													setValues((current) => ({
														...current,
														pedido: e.target.value,
													}));
													setValidator((current) => ({
														...current,
														validatorPedido: "true",
													}));
												}}
												onBlur={(e) => {
													verificaPedidoExiste();
												}}
												value={values.pedido || ""}
											/>
											{!pedidoValido && (
												<div className="error-text">Obrigatório!</div>
											)}
										</div>
									</div>
									{loadingSelectRota ? (
										<LoadingBar />
									) : (
										<div
											className={
												tipoRotaValido ? "coluna-emb" : "coluna-emb-erro"
											}
										>
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Rota:
												</p>
												<FormControl sx={{ width: 270 }}>
													<Select
														value={valuesSelect.tipoRota || ""}
														isDisabled={props.desabilitar}
														onInputChange={(value) => setFiltroRota(value)}
														options={opcoesRotaDefault.map((data) => ({
															value: data.nome,
															label: `${data.nome}
                                                                                                @ ${data.cidadeDestinoRota.cidade}
                                                                                                - ${data.cidadeDestinoRota.abreviacao}
                                                                                                - ${data.cidadeOrigemRota.cidade}
                                                                                                - ${data.cidadeOrigemRota.abreviacao}`,
														}))}
														formatOptionLabel={labelRota}
														styles={
															tipoRotaValido ? estiloRota : customStylesErro
														}
														placeholder=""
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																const rotaSelecionado = opcoesRota.find(
																	(option) =>
																		option.nome === selectedOption.value
																);
																setTipoRotaValido(true);
																setValues((current) => ({
																	...current,
																	rotaId: rotaSelecionado.idRota,
																	tipoRota: rotaSelecionado.nome,
																}));
																buscarTaxaIcms(
																	rotaSelecionado.estadoOrigem,
																	rotaSelecionado.estadoDestino
																);
																setValuesSelect((current) => ({
																	...current,
																	tipoRota: selectedOption,
																}));
																setValidator((current) => ({
																	...current,
																	validatorTipoRota: "true",
																}));
															}
														}}
													/>
												</FormControl>
												{!tipoRotaValido && (
													<div className="error-text">Obrigatório!</div>
												)}
											</div>
											<NewIcon
												onClick={(e) => {
													setOpenCadastroRota(true);
													setIdAtual(null);
													setDisable(false);
												}}
											/>
										</div>
									)}
									<div
										className={
											freteFiscalValido ? "coluna-emb" : "coluna-emb-erro"
										}
									>
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												Frete Fiscal:
											</p>
											<input
												type="text"
												id="frete"
												className={
													!freteFiscalValido ? "validacao-erro" : "input-emb"
												}
												style={{ width: "270px" }}
												onChange={(e) => {
													setFreteFiscalValido(true);
													setValues((current) => ({
														...current,
														freteFiscal: e.target.value,
													}));
													setValidator((current) => ({
														...current,
														validatorFreteFiscal: "true",
													}));
													if (
														taxaIcms === 0 ||
														taxaIcms === 0.0 ||
														taxaIcms === 0.0 ||
														taxaIcms === "0,00" ||
														taxaIcms === "0,0"
													) {
														setValues((current) => ({
															...current,
															icms: "0",
														}));
													} else {
														if (taxaIcms === undefined) {
															setValues((current) => ({
																...current,
																icms: "",
															}));
														}
													}
												}}
												onBlur={(e) => {
													setValues((current) => ({
														...current,
														freteFiscal: normalizeCurrency(
															e.target.value
														),
													}));
													setValidator((current) => ({
														...current,
														validatorFreteFiscal: "true",
													}));
												}}
												value={values.freteFiscal || ""}
												disabled={props.desabilitar}
											/>
											{!freteFiscalValido && (
												<div className="error-text">Obrigatório!</div>
											)}
										</div>
									</div>
									<div className="coluna-emb">
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												ICMS:
											</p>
											<input
												type="text"
												id="icms"
												className="input-emb"
												style={{ width: "270px" }}
												onChange={(e) => {
													setValues((current) => ({
														...current,
														icms: e.target.value,
													}));
												}}
												value={
													values.cliente ? values.icms : "Informe o Cliente"
												}
												disabled={true}
											/>
										</div>
									</div>
								</div>
								<div className="coluna-3-emb">
									<div
										className={pedagioValido ? "coluna-emb" : "coluna-emb-erro"}
									>
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												Pedágio:
											</p>
											<input
												type="text"
												id="pedagio"
												className={
													!pedagioValido ? "validacao-erro" : "input-emb"
												}
												style={{ width: "186px" }}
												onChange={(e) => {
													setPedagioValido(true);
													setValues((current) => ({
														...current,
														pedagio: e.target.value,
													}));
													setValidator((current) => ({
														...current,
														validatorPedagio: "true",
													}));
													if (
														taxaIcms === 0 ||
														taxaIcms === 0.0 ||
														taxaIcms === 0.0 ||
														taxaIcms === "0,00" ||
														taxaIcms === "0,0"
													) {
														setValues((current) => ({
															...current,
															icms: "0",
														}));
													} else {
														if (taxaIcms === undefined) {
															setValues((current) => ({
																...current,
																icms: "",
															}));
														}
													}
												}}
												onBlur={(e) => {
													setValues((current) => ({
														...current,
														pedagio: normalizeCurrency(
															e.target.value
														),
													}));
													setValidator((current) => ({
														...current,
														validatorPedagio: "true",
													}));
												}}
												value={values.pedagio || ""}
												disabled={props.desabilitar}
											/>
											{!pedagioValido && (
												<div className="error-text">Obrigatório!</div>
											)}
										</div>
									</div>
									{loadingSelectCliente ? (
										<LoadingBar />
									) : (
										<div
											className={
												clienteValido ? "coluna-emb" : "coluna-emb-erro"
											}
										>
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Cliente:
												</p>
												<FormControl sx={{ width: 250 }}>
													<Select
														value={valuesSelect.cliente || ""}
														isDisabled={props.desabilitar}
														options={opcoesClienteDefault}
														onInputChange={(value) => setFiltroCliente(value)}
														formatOptionLabel={labelCliente}
														styles={
															clienteValido ? estiloRota : customStylesErro
														}
														placeholder=""
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setClienteValido(true);
																setValuesSelect((current) => ({
																	...current,
																	cliente: selectedOption,
																}));
																setValuesSelect((current) => ({
																	...current,
																	labelCliente: `${selectedOption.nomeFantasia
																		} | ${selectedOption.apelido
																			? selectedOption.apelido
																			: "Favor, cadastrar apelido de Cliente"
																		}`,
																}));
																if (selectedOption.apelido === null) {
																	setValues((current) => ({
																		...current,
																		cliente: selectedOption.nomeFantasia,
																	}));
																} else {
																	setValues((current) => ({
																		...current,
																		cliente: selectedOption.apelido,
																	}));
																}
																setValues((current) => ({
																	...current,
																	clienteId: selectedOption.idCliente,
																}));
																setValidator((current) => ({
																	...current,
																	validatorCliente: "true",
																}));
															}
														}}
													/>
												</FormControl>
												{!clienteValido && (
													<div className="error-text">Obrigatório!</div>
												)}
											</div>
											<NewIcon
												onClick={(e) => {
													setOpenCadastroCliente(true);
													setIdAtual(null);
													setDisable(false);
												}}
											/>
										</div>
									)}
									{loadingSelectCliente ? (
										<LoadingBar />
									) : (
										<div
											className={
												embarcadorValido ? "coluna-emb" : "coluna-emb-erro"
											}
										>
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Embarcador:
												</p>
												<FormControl sx={{ width: 250 }}>
													<Select
														value={valuesSelect.embarcador || ""}
														isDisabled={props.desabilitar}
														options={opcoesEmbarcadorDefault}
														onInputChange={(value) => setFiltroEmbarcador(value)}
														formatOptionLabel={labelEmbarcador}
														styles={
															embarcadorValido ? estiloRota : customStylesErro
														}
														placeholder=""
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setEmbarcadorValido(true);
																setValuesSelect((current) => ({
																	...current,
																	embarcador: selectedOption,
																}));
																setValuesSelect((current) => ({
																	...current,
																	labelEmbarcador: `${selectedOption.nomeFantasia
																		} | ${selectedOption.apelido
																			? selectedOption.apelido
																			: "Favor, cadastrar apelido de Cliente"
																		}`,
																}));
																if (selectedOption.apelido === null) {
																	setValues((current) => ({
																		...current,
																		embarcador: selectedOption.nomeFantasia,
																	}));
																} else {
																	setValues((current) => ({
																		...current,
																		embarcador: selectedOption.apelido,
																	}));
																}
																setValues((current) => ({
																	...current,
																	embarcadorId: selectedOption.idCliente,
																}));
																setValuesClientesKm((current) => ({
																	...current,
																	idClienteOrigem: selectedOption.idCliente,
																}));
																setValidator((current) => ({
																	...current,
																	validatorEmbarcador: "true",
																}));
															}
														}}
													/>
												</FormControl>
												{!embarcadorValido && (
													<div className="error-text">Obrigatório!</div>
												)}
											</div>
											<NewIcon
												onClick={(e) => {
													setOpenCadastroCliente(true);
													setIdAtual(null);
													setDisable(false);
												}}
											/>
										</div>
									)}
									{loadingSelectCliente ? (
										<LoadingBar />
									) : (
										<div
											className={
												destinatarioValido ? "coluna-emb" : "coluna-emb-erro"
											}
										>
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Destinatário:
												</p>
												<FormControl sx={{ width: 250 }}>
													<Select
														value={valuesSelect.destinatario || ""}
														isDisabled={props.desabilitar}
														options={opcoesDestinatarioDefault}
														onInputChange={(value) => setFiltroDestinatario(value)}
														formatOptionLabel={labelDestinatario}
														styles={
															destinatarioValido ? estiloRota : customStylesErro
														}
														placeholder=""
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setDestinatarioValido(true);
																setValuesSelect((current) => ({
																	...current,
																	destinatario: selectedOption,
																}));
																setValuesSelect((current) => ({
																	...current,
																	labelDestinatario: `${selectedOption.nomeFantasia
																		} | ${selectedOption.apelido
																			? selectedOption.apelido
																			: "Favor, cadastrar apelido de Cliente"
																		}`,
																}));
																if (selectedOption.apelido === null) {
																	setValues((current) => ({
																		...current,
																		destinatario: selectedOption.nomeFantasia,
																	}));
																} else {
																	setValues((current) => ({
																		...current,
																		destinatario: selectedOption.apelido,
																	}));
																}
																setValues((current) => ({
																	...current,
																	destinatarioId: selectedOption.idCliente,
																}));
																setValuesClientesKm((current) => ({
																	...current,
																	idClienteDestino: selectedOption.idCliente,
																}));
																setValidator((current) => ({
																	...current,
																	validatorDestinatario: "true",
																}));
															}
														}}
													/>
												</FormControl>
												{!destinatarioValido && (
													<div className="error-text">Obrigatório!</div>
												)}
											</div>
											<NewIcon
												onClick={(e) => {
													setOpenCadastroCliente(true);
													setIdAtual(null);
													setDisable(false);
												}}
											/>
										</div>
									)}
								</div>
								<div className="coluna-3-emb">
									<div className={kmValido ? "coluna-emb" : "coluna-emb-erro"}>
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												KM:
											</p>
											<input
												type="text"
												id="km"
												className={!kmValido ? "validacao-erro" : "input-emb"}
												style={{ width: "210px" }}
												onChange={(e) => {
													setKMValido(true);
													setValues((current) => ({
														...current,
														km: e.target.value,
													}));
													setValidator((current) => ({
														...current,
														validatorKM: "true",
													}));
												}}
												value={valorMaskKm(values.km) || ""}
												disabled={props.desabilitar}
											/>
											{!kmValido && (
												<div className="error-text">Obrigatório!</div>
											)}
										</div>
									</div>
									<div
										className={
											classificacaoValido ? "coluna-emb" : "coluna-emb-erro"
										}
									>
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												Classificação/Descarga:
											</p>
											<input
												type="text"
												className={
													!classificacaoValido ? "validacao-erro" : "input-emb"
												}
												style={{ width: "210px" }}
												id="classificacao"
												onChange={(e) => {
													setClassificacaoValido(true);
													setValues((current) => ({
														...current,
														classificacao: e.target.value,
													}));
													setValidator((current) => ({
														...current,
														validatorClassificacao: "true",
													}));
													if (
														!taxaIcms ||
														taxaIcms === 0.0 ||
														taxaIcms === 0.0 ||
														taxaIcms === "0,00" ||
														taxaIcms === "0,0"
													) {
														setValues((current) => ({
															...current,
															icms: "0",
														}));
													} else {
														if (taxaIcms === undefined) {
															setValues((current) => ({
																...current,
																icms: "",
															}));
														}
													}
												}}
												onBlur={(e) => {
													setValues((current) => ({
														...current,
														classificacao: normalizeCurrency(
															e.target.value
														),
													}));
													setValidator((current) => ({
														...current,
														validatorClassificacao: "true",
													}));
												}}
												value={values.classificacao || ""}
												disabled={props.desabilitar}
											></input>
											{!classificacaoValido && (
												<div className="error-text">Obrigatório!</div>
											)}
										</div>
									</div>
									<div
										className={
											freteMotoristaValido ? "coluna-emb" : "coluna-emb-erro"
										}
									>
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												Frete Motorista:
											</p>
											<input
												type="text"
												className={
													!freteMotoristaValido ? "validacao-erro" : "input-emb"
												}
												style={{ width: "210px" }}
												id="freteMotorista"
												onChange={(e) => {
													setFreteMotoristaValido(true);
													setValues((current) => ({
														...current,
														freteMotorista: e.target.value,
													}));
													setValidator((current) => ({
														...current,
														validatorFreteMotorista: "true",
													}));
												}}
												onBlur={(e) => {
													setValues((current) => ({
														...current,
														freteMotorista: normalizeCurrency(
															e.target.value
														),
													}));
													setValidator((current) => ({
														...current,
														validatorFreteMotorista: "true",
													}));
												}}
												value={values.freteMotorista || ""}
												disabled={props.desabilitar}
											></input>
											{!freteMotoristaValido && (
												<div className="error-text">Obrigatório!</div>
											)}
										</div>
									</div>
									<Separator direction="horizontal" size="md" />
									<div className="checkbox-group-formpedido">
										{!semAutorizacaoFreteFiscal && (
											<motion.div
												className="checkbox-formpedido"
												initial={{ opacity: 0 }}
												animate={{
													opacity: values.permiteAlterarFreteFiscal ? 1 : 0.5,
												}}
												whileHover={{ opacity: 1 }}
												transition={{ duration: 0.3 }}
											>
												<Checkbox
													checked={values.permiteAlterarFreteFiscal}
													onCheck={() => {
														setValues((current) => ({
															...current,
															permiteAlterarFreteFiscal:
																!current.permiteAlterarFreteFiscal,
														}));
													}}
												/>
												<p>Permite Alterar Frete Fiscal</p>
											</motion.div>
										)}
										<motion.div
											className="checkbox-formpedido"
											initial={{ opacity: 0 }}
											animate={{ opacity: values.icmsEmbutido ? 1 : 0.5 }}
											whileHover={{ opacity: 1 }}
											transition={{ duration: 0.3 }}
										>
											<Checkbox
												checked={values.icmsEmbutido}
												onCheck={() => {
													setValues((current) => ({
														...current,
														icmsEmbutido: !current.icmsEmbutido,
													}));
												}}
											/>
											<p>ICMS Embutido</p>
										</motion.div>
									</div>
								</div>
								<div className="coluna-3-emb">
									{loadingSelectValorEmbarque ? (
										<LoadingBar />
									) : (
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Valor Viagem:
												</p>
												<SelectEmbarqueV2
													classeCss={220}
													onChange={(e) => {
														setValuesSelect((current) => ({
															...current,
															valorEmbarqueId: e,
														}));
														setValues((current) => ({
															...current,
															valorEmbarqueId: e.id,
														}));
													}}
													onClick={(e) => {
														e.stopPropagation();
														setDisable(true);
														setOpenCadastroValorEmbarque(true);
													}}
													clearSelection={clearValorEmbarque}
													onInfoIconClick={setIdAtual}
													pequeno={true}
													id="idValorEmbarque"
													value={valuesSelect.valorEmbarqueId || ""}
													titulo="ValorEmbarque"
													dadosSelect={listaValores}
													referenciaId="rota"
													referenciaItem="rota"
													referenciaItem2="nome"
												/>
											</div>
											<NewIcon
												onClick={(e) => {
													setOpenCadastroValorEmbarque(true);
													setIdAtual(null);
													setDisable(false);
												}}
											/>
										</div>
									)}
									<div className="coluna-emb">
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												Observação:
											</p>
											<input
												type="text"
												className="input-emb"
												style={{ width: "820px" }}
												id="observacao"
												onChange={(e) =>
													setValues((current) => ({
														...current,
														observacao: e.target.value,
													}))
												}
												value={values.observacao || ""}
												disabled={props.desabilitar}
											></input>
										</div>
									</div>
								</div>
								<div className="rota-div-2">
									<div className="coluna-emb">
										<div>
											<p className="input-label-emb" htmlFor="descricao">
												Frete Normal:
											</p>
											<input
												type="text"
												className="input-emb"
												style={{ width: "250px" }}
												id="freteNormal"
												value={values.freteNormal}
												disabled={true}
											/>
										</div>
									</div>
									<div className="single-checkbox-formpedido">
										<motion.div
											className="checkbox-formpedido"
											initial={{ opacity: 0 }}
											animate={{ opacity: values.icmsEmbarcador ? 1 : 0.5 }}
											whileHover={{ opacity: 1 }}
											transition={{ duration: 0.3 }}
										>
											<Checkbox
												checked={values.icmsEmbarcador}
												onCheck={() => {
													setValues((current) => ({
														...current,
														icmsEmbarcador: !current.icmsEmbarcador,
													}));
												}}
											/>
											<p>ICMS Embarcador</p>
										</motion.div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="footer-container">
						{editando ? (
							<CustomButtonV2
								classCss="custom-button-cadastrar"
								classText="button-texto-cadastrar"
								icone="iconeSave"
								titulo="Salvar"
								disabled={loadingCadastro}
								cor="#0946B8"
								valor={values}
								onClick={() => {
									editar();
								}}
							/>
						) : (
							<>
								{!props.desabilitar ? (
									props.botaoCadastrar ? (
										<CustomButtonV2
											classCss="custom-button-cadastrar"
											classText="button-texto-cadastrar"
											icone="iconeSave"
											titulo="Salvar"
											disabled={loadingCadastro}
											cor="#0946B8"
											valor={values}
											onClick={() => {
												cadastrar();
											}}
										/>
									) : (
										<CustomButtonV2
											classCss="custom-button-cadastrar"
											classText="button-texto-cadastrar"
											icone="iconeSave"
											titulo="Salvar"
											disabled={loadingCadastro}
											cor="#0946B8"
											valor={values}
											onClick={() => {
												if (values.icms === "0") {
													setValues((current) => ({
														...current,
														icms: "0,00",
													}));
												}
												if (
													values.icms !== undefined &&
													values.icms !== "NaN" &&
													values.icms !== NaN &&
													values.icms !== null &&
													values.icms !== "SemTaxa" &&
													values.pedido !== undefined &&
													values.icms !== "" &&
													values.freteFiscal !== "" &&
													values.pedido !== "" &&
													values.rota !== "" &&
													values.pedagio !== "" &&
													values.km !== "" &&
													values.cliente !== "" &&
													values.classificacao !== "" &&
													values.embarcador !== "" &&
													values.destinatario !== "" &&
													values.pedido !== "" &&
													values.freteMotorista !== "" &&
													validator.validatorTipoRota === "true" &&
													validator.validatorFreteFiscal === "true" &&
													validator.validatorPedagio === "true" &&
													validator.validatorKM === "true" &&
													validator.validatorCliente === "true" &&
													validator.validatorClassificacao === "true" &&
													validator.validatorEmbarcador === "true" &&
													validator.validatorDestinatario === "true" &&
													validator.validatorFreteMotorista === "true"
												) {
													cadastrar();
												} else {
													if (values.pedido === "") {
														setPedidoValido(false);
													}
													if (
														validator.validatorTipoRota === "false" ||
														values.tipoRota === ""
													) {
														setTipoRotaValido(false);
													}
													if (
														validator.validatorFreteFiscal === "false" ||
														values.freteFiscal === ""
													) {
														setFreteFiscalValido(false);
													}
													if (
														validator.validatorPedagio === "false" ||
														values.pedagio === ""
													) {
														setPedagioValido(false);
													}
													if (
														validator.validatorKM === "false" ||
														values.km === ""
													) {
														setKMValido(false);
													}
													if (
														validator.validatorCliente === "false" ||
														values.cliente === ""
													) {
														setClienteValido(false);
													}
													if (
														validator.validatorClassificacao === "false" ||
														values.classificacao === ""
													) {
														setClassificacaoValido(false);
													}
													if (
														validator.validatorDestinatario === "false" ||
														values.destinatario === ""
													) {
														setDestinatarioValido(false);
													}
													if (
														validator.validatorEmbarcador === "false" ||
														values.embarcador === ""
													) {
														setEmbarcadorValido(false);
													}
													if (
														validator.validatorFreteMotorista === "false" ||
														values.freteMotorista === ""
													) {
														setFreteMotoristaValido(false);
													}
													setTextoErro("Há campos sem preencher!");
													setOpenToastErro(true);
												}
											}}
										/>
									)
								) : (
									<></>
								)}
							</>
						)}
						{!props.botaoVoltar && (
							<CustomButtonV2
								classCss="custom-button-cancelar"
								classText="button-texto-cancelar"
								titulo="Cancelar"
								cor="#0946B8"
								valor={values}
								onClick={() => {
									setValues({});
									setDadosTabela(dadosTabelaCopia);
									setValuesSelect({});
									setTelaCadastro(false);
									setEditando(false);
									setTabelaRedux({});
								}}
							/>
						)}
					</div>
				</MotionContainer>
			)}
			<ModalConfigTabela
				titulo="Colunas Visíveis"
				tituloConfirmar="OK"
				open={openConfig}
				onClose={handleCloseConfig}
				checks={colunasHistorico}
				nome="pedido"
			/>
		</>
	);
}
